import styled from "styled-components"

export const MusicPlayerEQContainer = styled.div`
  width: 100%;
  display: flex;
  position: relative;

  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 20px;

  @media (max-width: ${({ theme }) => theme.breakpoint.tablet - 1}px) {
    height: 50%;
  }

  audio {
    top: 0;
    left: 0;
    position: absolute;
    visibility: hidden;
  }

  img {
    margin: 0;
    max-width: 100%;
    padding: 0 10px;
  }

  min-height: 65px;

  &:hover {
    text-decoration: none;
  }

  img {
    max-width: 22px;
  }

  span {
    line-height: 1.5;
  }
`

export const AnimationBars = styled.div`
  height: 30px;
  flex: 1;
  display: grid;
  overflow: hidden;

  align-items: flex-end;
  grid-column-gap: 1px;
  grid-template-columns: repeat(auto-fit, minmax(3px, 1fr));

  position: relative;
`

export const AnimationBarWrapper = styled.div`
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: stretch;
`

export const AnimationBar = styled.div.attrs<{
  animated: boolean
  duration: number
}>(({ duration, animated }) => ({
  style: {
    animationDuration: `${duration}s`,
    animationPlayState: animated ? "running" : "paused",
  },
}))<{
  animated: boolean
  duration: number
}>`
  height: 3px;
  width: 100%;
  background: #666;

  @keyframes sound {
    0% {
      opacity: 0.35;
      height: 3px;
    }
    100% {
      opacity: 1;
      height: 30px;
    }
  }

  animation: sound 0ms -800ms linear infinite alternate;
`
